<template>
 <div>
    <el-button type="primary" @click="JumpAdd" v-if="isShowAddBtn && judgePermission('vehicle_accident_list_create')">新建事故</el-button>
    <CarAccidentList :loading="oLoading" :params="params" :isCarDetail="isCarDetail" />
 </div>
</template>
<script>
import CarAccidentList from '@/pages/carsService/accident/components/carAccidentList.vue'

export default {
  components: {
    CarAccidentList,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    isShowAddBtn: {
      type: Boolean,
      default: false,
    },
    // 是否是详情页
    isCarDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oLoading: {
        search: false,
      },
    }
  },
  methods: {
    // 新建事故
    JumpAdd() {
      this.$router.push({
        path: '/vehicle/accident/add',
        query: {
          plateNo: this.plateNo,
        },
      })
    },
  },
}
</script>
